import { generateClient } from 'aws-amplify/api'
import { createRazorpayOrder as createRazorpayOrderMutation } from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export default {
  methods: {
    async createRazorpayOrder(input = {}) {
      try {
        const { data, errors } = await client.graphql({
          query: createRazorpayOrderMutation,
          variables: { input },
        })

        const parsed = parseAwsJson(data?.createRazorpayOrder)
        if (parsed != null) {
          return parsed
        }

        if (errors?.length) {
          throw new Error(errors[0].message)
        }

        return null
      } catch (error) {
        return {
          status: 'ERROR',
          message: getApiMessage(error, 'Failed to create payment order'),
        }
      }
    },
  },
}
